import React, { useEffect, useState } from "react";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingUI from "@/components/layout/FloatingUI";
import ScrollToTop from "@/components/layout/ScrollToTop";
import OpeningPopup from "@/components/layout/OpeningPopup";

import { AromaCubanaWhatsAppButton } from "@/components/chat/AromaCubanaWhatsAppButton";
import { AromaCubanaPopup } from "@/components/chat/AromaCubanaPopup";

import Home from "@/pages/Home";
import About from "@/pages/About";
import MenuPage from "@/pages/Menu";
import Contact from "@/pages/Contact";

import "@/App.css";

function App() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.fbgcdn.com/embedder/js/ewm2.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F1E8] text-[#3E2723]">
      <BrowserRouter>
        <ScrollToTop />
        <OpeningPopup />

        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/over-ons" element={<About />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

        <Footer />

        {/* 👉 NIEUWE WhatsApp flow */}
        <AromaCubanaWhatsAppButton onClick={() => setOpen(true)} />
        {open && <AromaCubanaPopup onClose={() => setOpen(false)} />}

        {/* 👉 Scroll to top (zonder WhatsApp erin) */}
        <FloatingUI />
      </BrowserRouter>
    </div>
  );
}

export default App;

